<script setup lang="ts">

const props = defineProps({
  hide: Boolean,
  isFilled: Boolean,
  text: String,
  order: Number,
})

const emit = defineEmits(['next', 'back'])
function handleBack() {
  emit('back',props.order)
}
function handleNext() {
  emit('next')
}
</script>

<template>
  <div
      class="order_section flex flex-col gap-6"
      :class="{ 'bg-primary-green bg-opacity-10' : isFilled }"
  >
    <div>
      <div class="flex justify-between items-center gap-6">
        <p class="h3">{{text}}</p>
        <UIBtn
            @click="handleBack"
            v-if="isFilled"
            border="green"
        >{{ $t('input_forms.button.edit') }}</UIBtn>
      </div>
     <slot  name="filled" />
    </div>
    <template v-if="!hide">
      <slot  name="input" />
      <UIBtn
          @click="handleNext"
             color="green"
             class="mt-6 ml-auto"
      >
        {{ $t('input_forms.button.next') }}
      </UIBtn>
    </template>
  </div>
</template>

<style scoped>

</style>